import {useEffect, useRef, useState} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {AppEntities, AppServices} from "../../../config/entities";
import {IAccountDto} from "../../../dtos/accounting/IAccountDto";
import {AccountTypeEnum} from "../../../enums/Accounting/AccountTypeEnum";
import TreeList, {Column, Sorting} from "devextreme-react/tree-list";
import ChartOfAccountsDetail from "./ChartOfAccountsDetail";
import {Popup} from "devextreme-react/popup";
import Swal from "sweetalert2";
import Loader from "../../../assets/img/svg/Loader";
import {useTranslation} from "react-i18next";
import {NFLoadPanel} from "../../Shared/NFLoadPanel";

const ChartOfAccountsList = () => {
    const {t} = useTranslation();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [groupItems, setGroupItems] = useState<IAccountDto[] | undefined>(
        undefined
    );
    const [selectedItemId, setSelectedItemId] = useState<string | undefined>(
        undefined
    );
    const [isDetailGroupViewOpen, setIsDetailGroupViewOpen] = useState(false);
    const [isDetailViewOpen, setIsDetailViewOpen] = useState<boolean>(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                setIsError(false);
                setErrorMessage("");
                const dataService = AppEntities.Account.getDataService();
                const chartOfAccounts = await dataService.GetAll();
                // const organizedItems = groupItemsByNumber(chartOfAccounts);
                setGroupItems(chartOfAccounts);
            } catch (e: any) {
                setIsError(true);
                setErrorMessage(e.message);
                console.log(e.message);
            } finally {
                setIsLoading(false);
                setDataLoaded(true);
            }
        };
        fetchData();
    }, []);

    // const groupItemsByNumber = (chartOfAccounts: IAccountDto[]): IAccountDto[] => {
    //     const groupedItems: IAccountDto[] = [];
    //
    //     chartOfAccounts.forEach((item) => {
    //         const accountNo = item.accountNo.toString();
    //         const parentNumber = accountNo.split(".")[0];
    //
    //         if (!accountNo.includes(".")) {
    //             const topLevelItem: IAccountDto = {...item, parentId: null};
    //             groupedItems.push(topLevelItem);
    //         } else {
    //             const parentItem = groupedItems.find(
    //                 (group) => group.accountNo.toString() === parentNumber
    //             );
    //
    //             if (parentItem) {
    //                 if (!parentItem.children) {
    //                     parentItem.children = [];
    //                 }
    //                 const childItem: IAccountDto = {...item, parentId: parentItem.id};
    //                 parentItem.children.push(childItem);
    //             } else {
    //                 const topLevelItem: IAccountDto = {...item, parentId: null};
    //                 groupedItems.push(topLevelItem);
    //             }
    //         }
    //     });
    //
    //     return groupedItems;
    // };

    const getAccountType = (accountType: AccountTypeEnum) => {
        switch (accountType) {
            case AccountTypeEnum.Active:
                return t("Active");
            case AccountTypeEnum.Passive:
                return t("Passive");
            case AccountTypeEnum.ActivePassive:
                return t("Active/Passive");
            default:
                return t("Unknown");
        }
    };
    // if (!dataLoaded) {
    //     return (
    //         <div className="loader-rs">
    //             <div className="loader-rs-icon mt-5">
    //                 <Loader/>
    //             </div>
    //         </div>
    //     );
    // }

    const handleCreateNewClick = () => {
        setIsDetailViewOpen(true);
        setIsDetailGroupViewOpen(false);
        setSelectedItemId(undefined);
    };

    const handleCloseModal = () => {
        setIsDetailViewOpen(false);
    };
    const handleDeleteAccount = async () => {
        if (selectedItemId) {
            try {
                const response = await AppServices.Axios.delete(
                    `/Accounts/${selectedItemId}`
                );

                if (response.status === 200) {
                    const updatedGroupItems = groupItems?.filter(
                        (item) => item.id !== selectedItemId
                    );
                    setGroupItems(updatedGroupItems);
                    setSelectedItemId(undefined);
                } else {
                    await Swal.fire({
                        title: "Error",
                        text: "An Error occured while deleting the account",
                        icon: "error",
                    });
                }
            } catch (error) {
                await Swal.fire({
                    title: "Error",
                    text: "An Error occured while deleting the account",
                    icon: "error",
                });
            }
        }
    };

    const handleAccountRowClick = (e: any) => {
        setSelectedItemId(e.data.id);
    };

    const handleRowDblClick = (e: any) => {
        setIsDetailViewOpen(true);
        setSelectedItemId(e.data.id);
        setIsDetailGroupViewOpen(false);
    }

    if (isError) {
        return <div className={"alert alert-danger"}>{errorMessage}</div>;
    }
    
    return (
        <>
            <div className="main-container container-fluid ">
                <div className="listview-card">
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Button
                            size={"sm"}
                            variant=""
                            className="btn btn-primary mb-3 me-2"
                            onClick={handleCreateNewClick}
                        >
                            {t("AddAccount")}
                        </Button>
                        <div style={{display: "flex", justifyContent: "flex-end"}}>
                            {/*<Button*/}
                            {/*    size={"sm"}*/}
                            {/*    variant=""*/}
                            {/*    className="btn btn-light mb-3 me-2"*/}
                            {/*    disabled={!selectedItemId}*/}
                            {/*>*/}
                            {/*    Clone*/}
                            {/*</Button>*/}
                            <div>
                                <Button
                                    size={"sm"}
                                    variant=""
                                    className="btn btn-light mb-3 me-2"
                                    disabled={!selectedItemId}
                                    onClick={() => {
                                        setIsDetailViewOpen(true);
                                        setSelectedItemId(selectedItemId);
                                        setIsDetailGroupViewOpen(false);
                                    }}
                                >
                                    Edit
                                </Button>
                                <Button
                                    size={"sm"}
                                    variant=""
                                    className="btn btn-light mb-3 me-2"
                                    disabled={!selectedItemId}
                                    onClick={handleDeleteAccount}
                                >
                                    Delete
                                </Button>
                            </div>
                        </div>
                    </div>


                    <TreeList
                        dataSource={groupItems}
                        showRowLines={true}
                        autoExpandAll={true}
                        focusedRowEnabled={true}
                        keyExpr="id"
                        showBorders={true}
                        columnAutoWidth={true}
                        allowColumnReordering={true}
                        // dataStructure="tree"
                        // itemsExpr="children"
                        parentIdExpr={"parentId"}
                        onRowClick={handleAccountRowClick}
                        onRowDblClick={handleRowDblClick}
                        
                    >
                        <Sorting mode="multiple" />
                        <Column dataField="accountNo" caption="Account #" sortIndex={0} width={150} defaultSortOrder="asc"/>
                        <Column dataField="name" caption="Name" width={400}/>
                        <Column
                            dataField="accountType"
                            caption="Account type"
                            cellRender={(data) => getAccountType(data.value)}
                            width={150}
                        />
                        <Column
                            dataField="isQuantity"
                            caption="Is Quantity"
                            cellRender={(data) => (data.value === true ? "Yes" : "No")}
                        />
                        <Column
                            dataField="isAmount"
                            caption="Is Amount"
                            cellRender={(data) => (data.value === true ? "Yes" : "No")}
                        />
                        <Column
                            dataField="isCurrency"
                            caption="Is Currency"
                            cellRender={(data) => (data.value === true ? "Yes" : "No")}
                        />
                        <Column
                            dataField="typeOfAnalytics1Name"
                            caption="Analytic 1"
                        />
                        <Column
                            dataField="typeOfAnalytics2Name"
                            caption="Analytic 2"
                        />
                        <Column
                            dataField="typeOfAnalytics3Name"
                            caption="Analytic 3"
                        />
                    </TreeList>
                </div>
            </div>

            {isDetailViewOpen && <ChartOfAccountsDetail
                visible={isDetailViewOpen}
                onCloseModal={handleCloseModal}
                groupItems={groupItems}
                setGroupItems={setGroupItems}
                selectedItemId={selectedItemId}
            />}
            
            <NFLoadPanel isLoading={isLoading} message={t("Loading")} />
        </>
    );
};

export default ChartOfAccountsList;
